import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './Components/layout/MainLayout';
import DigitalElevationView from './Components/DEMView'; // renamed from DEMView
import CropHealthMonitoringView from './Components/CHMPage/CHMPage'; // renamed from CHMPage
import IndicesAnalytics from './Components/all-charts/AllChart'; // renamed from AllChart
import CropMappingView from './Components/CropwiseData/CropwiseData'; // renamed from CropwiseData
import WeatherDetailsView from './Components/WeatherDetails/WeatherDetails'; //Weather DetailsPage
import CycloneTrackingView from './Components/CycloneMap/CycloneMap';// Cyclone Data Page

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          {/* 1. Elevation Overview */}
          <Route index element={<IndicesAnalytics />} />
          <Route path="elevation/dem" element={<DigitalElevationView />} />

          {/* 2. Crop Health Monitoring (Points + Satellite Images) */}
          <Route path="crop-monitoring" element={<CropHealthMonitoringView />} />

          {/* 3. Vegetation Indices (NDVI, SAVI, etc.) */}
          <Route path="analytics/indices" element={<IndicesAnalytics />} />

          {/* 4. Crop Maps (Moong, Bajra, Wheat, etc.) */}
          <Route path="agriculture/crop-maps" element={<CropMappingView />} />

          {/* 5. Cyclone Risk/Tracking */}
          <Route path="climate/cyclones" element={<CycloneTrackingView />} />

          {/* Optional: Weather */}
          <Route path="climate/weather" element={<WeatherDetailsView />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
